<div class="label-info-wrapper">
  <ng-container [formGroup]="form">
    <label>
      <div class="container">
        <img class="icon-payment-method" [src]="iconSrc" [alt]="value" />
        <span>{{ label }}</span>
        <input
          [id]="value"
          [value]="value"
          type="radio"
          [name]="controlName"
          [formControl]="$any(form.get(controlName))"
        />
        <!-- There seems to be a bug when using formControlName with radio buttons in a child component. In the ui the radio buttons did not get unselected when selecting an other radio button. Using formControl and name works. -->
      </div>
    </label>
  </ng-container>
  <ez-info-popover [popoverText]="popoverText"></ez-info-popover>
</div>
